import { API, graphqlOperation } from "aws-amplify";

import { listJobRolesQuery } from "./graphql/queries";

const listJobRoles = () => API.graphql(graphqlOperation(listJobRolesQuery));

export default listJobRoles;
